import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { format } from "date-fns";
import CreatableSelect from "react-select/creatable";
import { config, encodeBase64RequestBody, nameFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const ClientAdd = () => {
  const [ companies, setCompanies ] = useState(null);
  const [ companyName, setCompanyName ] = useState('');
  const [ companyDomain, setCompanyDomain ] = useState('');
  const [ companyBillingName, setCompanyBillingName ] = useState('');
  const [ companyStatus, setCompanyStatus ] = useState(true);
  const [ selectedName, setSelectedName ] = useState(null);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    if (selectedName) {
      setCompanyName(selectedName.label ? nameFormat(selectedName.label) : '');
    }
  }, [selectedName]);

  const changeCompanyName = (name) => {
    setSelectedName({
      value: 0,
      label: name,
      isDisabled: false
    });
    setCompanyName(name);
  }

  const getCompanies = async () => {
    try {
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody({})
      });
      const responseCompanies = await fetchCompanies.json();
      if (responseCompanies.status === 200) {
        const companies = [];
        for (let c in responseCompanies.data) {
          companies.push({
            value: responseCompanies.data[c].id_company,
            label: responseCompanies.data[c].company_name,
            isDisabled: true
          });
        }
        setCompanies(companies);
      } else {
        alert(responseCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const submitCompanyAdd = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));

      const requestCompanyAdd = {
        "company_name": companyName ? companyName.trim() : '',
        "company_domain": companyDomain ? companyDomain.trim() : '',
        "company_billing_name": companyBillingName ? companyBillingName.trim() : '',
        "company_status": companyStatus === true ? 'Active' : 'Inactive',
        "created_on": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "created_by": crmUser.user_keyid,
      }

      const fetchCompanyAdd = await jwtFetch(config.ENDPOINT + 'create/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestCompanyAdd)
      });
      const responseCompanyAdd = await fetchCompanyAdd.json();
      if (responseCompanyAdd.status === 200) {
        window.location.href = '/client';
      } else {
        alert(responseCompanyAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitCompanyAdd:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="client-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="client"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <a className="text-secondary" href="/client">Client List</a>
                    <span className="mx-3"><i className="bi bi-chevron-right"/></span>
                    <span>Company Group Add</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="fs-24">Company Group Add</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <form className="bg-white border-radius-4 p-4" onSubmit={(e) => submitCompanyAdd(e)}>
                        <div className="border border-1 border-radius-3 p-4 mb-3">
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Group Name <span className="text-danger">*</span></label>
                            </div>
                            <div className="col-md-8">
                              <CreatableSelect options={companies} value={selectedName} placeholder="Type name..." onCreateOption={(e) => changeCompanyName(e)} isClearable required/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Legal Name <span className="text-danger">*</span></label>
                            </div>
                            <div className="col-md-8">
                              <input className="form-control" type="text" value={companyBillingName} onChange={(e) => setCompanyBillingName(e.target.value)} required/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Domain</label>
                            </div>
                            <div className="col-md-8">
                              <input className="form-control" type="text" value={companyDomain} onChange={(e) => setCompanyDomain(e.target.value)}/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-4">
                            <div className="col-md-4">
                              <label>Status</label>
                            </div>
                            <div className="col-md-8">
                              <div className="form-check form-switch">
                                <input id="status" className="form-check-input" type="checkbox" value={true} onChange={() => setCompanyStatus(!companyStatus)} checked={companyStatus}/>
                                <label htmlFor="status" className="form-check-label">{companyStatus ? 'Active' : 'Inactive'}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-link" type="button" onClick={() => window.location.href = "/client"}>Cancel</button>
                          <button className="btn bg-gold ms-2" type="submit">{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientAdd;


